import axios from 'axios'
import requestErrorServices from '../services/requestErrorServices'

export default class {
  // apelle une requete DELETE
  static delete (url, data) {
    return new Promise((resolve, reject) => {
      axios.delete(url, data)
        .then(function (response) {
          resolve(response.data)
        })
        .catch(function (error) {
          // renvoyer l'erreur
          requestErrorServices.manageError(error)
          reject(error)
        })
    })
  }

  // apelle une requete PUT
  static put (url, data, config) {
    return new Promise((resolve, reject) => {
      axios.put(url, data, config)
        .then(function (response) {
          resolve(response.data)
        })
        .catch(function (error) {
          // renvoyer l'erreur
          requestErrorServices.manageError(error)
          reject(error)
        })
    })
  }

  // apelle une requete POST
  static post (url, data, config) {
    return new Promise((resolve, reject) => {
      axios.post(url, data, config)
        .then(function (response) {
          resolve(response.data)
        })
        .catch(function (error) {
          // renvoyer l'erreur
          requestErrorServices.manageError(error)
          reject(error)
        })
    })
  }

  // appele une requete GET
  static get (url) {
    return new Promise((resolve, reject) => {
      axios.get(url)
        .then(function (response) {
          resolve(response.data)
        })
        .catch(function (error) {
          // renvoyer l'erreur
          requestErrorServices.manageError(error)
          reject(error)
        })
    })
  }

  static download (url) {
    return new Promise((resolve, reject) => {
      axios({
        url: url,
        method: 'GET',
        responseType: 'blob',
        timeout: 100000
      })
        .then(function (response) {
          const blob = new Blob([response.data], { type: response.data.type })
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          const contentDisposition = response.headers['content-disposition']
          // console.log('contentDisposition=', contentDisposition)
          let fileName = 'unknown'
          if (contentDisposition) {
            const regex = /filename=(.+);/
            let m
            if ((m = regex.exec(contentDisposition)) !== null) {
              fileName = m[1]
            }
          }
          // console.log('fileName=', fileName)
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          link.remove()
          window.URL.revokeObjectURL(url)
          resolve(response.data)
        })
        .catch(function (error) {
          // renvoyer l'erreur
          requestErrorServices.manageError(error)
          if (error.response.data instanceof Blob) {
            const fr = new FileReader()
            fr.onload = function () {
              error.response.data = JSON.parse(this.result)
              reject(error)
            }
            fr.readAsText(error.response.data)
          } else {
            reject(error)
          }
        })
    })
  }

  openFile (response) {

  }
}
